var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{staticClass:"tooltip",attrs:{"top":"","max-width":"400"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"tooltip__text",class:_vm.classes,style:({width: _vm.width, height: _vm.height}),on:{"click":function($event){return _vm.$emit('click')}}},on),[_vm._v(_vm._s(_vm.text))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }